import { useTranslation } from 'next-i18next';
import {
  Layout,
  Illustration,
  StyledText,
  StyledTitle,
} from './styles';
import construction from 'assets/illustrations/construction.png';

export const Maintenance = () => {
  const { t } = useTranslation('common');

  return (
    <Layout>
      <Illustration
        alt='Under Construction'
        placeholder='blur'
        src={construction}
      />
      <StyledTitle>{t('MAINTENANCE.TITLE')}</StyledTitle>
      <StyledText>{t('MAINTENANCE.SUBTITLE')}</StyledText>
    </Layout>
  );
};
